import { render, staticRenderFns } from "./simpleCard.vue?vue&type=template&id=0c3b15e0&scoped=true&"
import script from "./simpleCard.vue?vue&type=script&lang=js&"
export * from "./simpleCard.vue?vue&type=script&lang=js&"
import style0 from "./simpleCard.vue?vue&type=style&index=0&id=0c3b15e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b15e0",
  null
  
)

export default component.exports